import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';

export default class DocTypeApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAllDocumentTypeAttributes(
    attributeKeysCsv: string,
  ): Promise<any> {
    return super.get(
      api.get_all_document_type_attributes +
        '?attribute_keys=' +
        attributeKeysCsv,
      {},
    );
  }

  public async getAttributesByDocKey(data: dynamicObj): Promise<any> {
    let querystring = this.encodeQueryData(data);

    const sub_org_id = await this.getSubOrgId();
    if (sub_org_id) {
      querystring += '&sub_org_id=' + sub_org_id;
    }
    return super.get(api.get_document_type_attributes + '?' + querystring, {});
  }

  public async setAttribute(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.set_document_type_attribute, formData);
  }

  public async deleteDocumentTypeAttribute(id: string): Promise<any> {
    const formData = new FormData();
    formData.append('id', id);
    return super.delete(api.delete_document_type_attribute, formData);
  }
}
